import { GlEmptyState, GlModal, GlSprintf } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
export default {
    name: 'WorkItemTicketModal',
    components: {
        GlEmptyState,
        GlModal,
        GlSprintf
    },
    emits: [
        'hide'
    ]
};
